/** Groups PRO-FRONTEND-JZAP (response_json_parsing) and PRO-FRONTEND-JZAN (request_failed). */
export const I18N_INIT_SENTRY_MESSAGE = "I18n unable to initialize Localization configuration";

/**
 * Groups PRO-FRONTEND-JPN9 (track.json) and PRO-FRONTEND-JKF4 (education.json).
 * Raised by `fetchJsonWithSentry` when `res.text()` is aborted mid-read; the error is
 * gracefully handled with a fallback value, so it's pure noise in headless automation runs.
 */
export const RESOURCE_FETCH_SENTRY_MESSAGE = "Failed to read response text from";
